export default __webpack_public_path__ + "static/media/camera.7c5bbc3b.jpeg";